module.exports = __webpack_public_path__ + "static/img/noList.4cd04359.png";